import React from 'react';
import Box from '@material-ui/core/Box';
import {ColumnType} from '@pluto/table/tableTypes';
import Table from '@pluto/table';
import {DateRangeState, OnDatesSelect} from '@pluto/daterange-picker/DateRangeTypes';
import {OnChangeType} from '@pluto/lab-partners/LabPartnersTypes';
import MediaImport from '../MediaOrderImport/MediaOrderImportConnected';
import {MediaOrderListFilters} from '../MediaOrdersTypes';
import {MediaOrdersListItem, MediaOrdersChangeHandlerType} from './MediaOrdersListTypes';
import MediaOrdersListToolbar from './MediaOrdersListToolbar';
import './MediaOrdersList.scss';

interface Props {
    data: MediaOrdersListItem[];
    columns: ColumnType[];
    total: number;
    idValue: string;
    handleIdChange: MediaOrdersChangeHandlerType;
    handleContentPartnersChange: () => void;
    handleLabPartnersChange: OnChangeType;
    filters: {
        contentPartnerId: string;
        labPartner: string;
    };
    page: number;
    rowsPerPage: number;
    onPaging: () => void;
    setPage: (value: number) => void;
    setRowsPerPage: (value: number) => void;
    setFilter: (filters: MediaOrderListFilters) => void;
    setMediaOrderId: React.Dispatch<React.SetStateAction<string>>;
    onImportDateSelect: OnDatesSelect;
    onDateIssuedSelect: OnDatesSelect;
    dateIssued: DateRangeState;
    importDate: DateRangeState;
}

export default function MediaOrdersList(props: Props) {
    const {
        data,
        columns,
        total,
        idValue,
        handleIdChange,
        handleContentPartnersChange,
        handleLabPartnersChange,
        filters,
        onPaging,
        page,
        setPage,
        rowsPerPage,
        setRowsPerPage,
        setFilter,
        setMediaOrderId,
        dateIssued,
        importDate,
        onImportDateSelect,
        onDateIssuedSelect,
    } = props;

    return (
        <Box className="media-orders-list">
            <Box className="media-orders-list__header">
                <MediaOrdersListToolbar
                    inputText={idValue}
                    handleChange={handleIdChange}
                    handleContentPartnersChange={handleContentPartnersChange}
                    handleLabPartnersChange={handleLabPartnersChange}
                    filters={filters}
                    dateIssued={dateIssued}
                    onDateIssuedSelect={onDateIssuedSelect}
                    importDate={importDate}
                    onImportDateSelect={onImportDateSelect}
                />
                <MediaImport
                    setFilter={setFilter}
                    listRowsPerPage={rowsPerPage}
                    setMediaOrderId={setMediaOrderId}
                />
            </Box>
            <Table
                total={total}
                data={data}
                columns={columns}
                page={page}
                setPage={setPage}
                rowsPerPage={rowsPerPage}
                setRowsPerPage={setRowsPerPage}
                onChangePageHandler={onPaging}
            />
        </Box>
    );
}
